import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState(null);

  // فرض الوضع النهاري
  useEffect(() => {
    document.documentElement.removeAttribute('data-theme');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage({ type: 'error', text: 'يرجى إدخال البريد الإلكتروني' });
      return;
    }

    setLoading(true);
    setMessage(null);
    
    try {
      await axios.post(`${BACKEND_URL}/api/auth/forgot-password`, { email });
      setSent(true);
      setMessage({ type: 'success', text: 'تم إرسال رابط إعادة التعيين إلى بريدك الإلكتروني ✉️' });
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.detail || 'حدث خطأ، حاول مرة أخرى' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container islamic-pattern">
      <div className="card" style={{ maxWidth: '450px', width: '100%', padding: '40px 32px' }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ fontSize: '50px', marginBottom: '16px' }}>🔐</div>
          <h1 style={{ 
            fontSize: '24px', 
            color: '#00897B', 
            marginBottom: '8px',
            fontFamily: "'Amiri', serif"
          }}>
            نسيت كلمة المرور؟
          </h1>
          <p style={{ color: 'var(--text-light)', fontSize: '14px' }}>
            لا تقلق! أدخل بريدك الإلكتروني وسنرسل لك رابط لإعادة التعيين
          </p>
        </div>

        {/* Message */}
        {message && (
          <div style={{
            padding: '14px 18px',
            borderRadius: '10px',
            marginBottom: '20px',
            background: message.type === 'success' ? 'rgba(0, 180, 162, 0.1)' : 'rgba(211, 47, 47, 0.1)',
            color: message.type === 'success' ? '#00897B' : '#D32F2F',
            textAlign: 'center',
            border: `1px solid ${message.type === 'success' ? 'rgba(0, 180, 162, 0.2)' : 'rgba(211, 47, 47, 0.2)'}`
          }}>
            {message.text}
          </div>
        )}

        {!sent ? (
          /* Form */
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">البريد الإلكتروني</label>
              <input
                type="email"
                className="input"
                placeholder="example@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                dir="ltr"
                data-testid="forgot-email-input"
              />
            </div>
            
            <button 
              type="submit" 
              className="btn btn-primary btn-full" 
              disabled={loading}
              data-testid="send-reset-link-btn"
              style={{ 
                background: 'linear-gradient(135deg, #00897B, #00B4A2)',
                fontSize: '16px',
                padding: '14px'
              }}
            >
              {loading ? '⏳ جاري الإرسال...' : '📧 إرسال رابط إعادة التعيين'}
            </button>
          </form>
        ) : (
          /* Success State */
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
              fontSize: '60px', 
              marginBottom: '20px',
              animation: 'pulse 2s infinite'
            }}>
              📬
            </div>
            <h3 style={{ color: '#00897B', marginBottom: '12px' }}>تحقق من بريدك الإلكتروني</h3>
            <p style={{ color: 'var(--text-light)', lineHeight: '1.8', marginBottom: '20px' }}>
              أرسلنا رابط إعادة تعيين كلمة المرور إلى:<br/>
              <strong style={{ color: 'var(--text-dark)' }}>{email}</strong>
            </p>
            <p style={{ color: 'var(--text-light)', fontSize: '13px' }}>
              ⏰ الرابط صالح لمدة ساعة واحدة
            </p>
            
            <button 
              onClick={() => { setSent(false); setMessage(null); }}
              className="btn btn-outline"
              style={{ marginTop: '20px' }}
            >
              إعادة الإرسال
            </button>
          </div>
        )}

        {/* Back to Login */}
        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <button 
            onClick={() => navigate('/login')}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#00897B', 
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            ← العودة لتسجيل الدخول
          </button>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>
    </div>
  );
}

export default ForgotPasswordPage;
